const Config ={
          apiUrl: 'https://mobilecity.sparklabitservices.com/public/api',
          
};
 export default Config
